import { makeAutoObservable } from 'mobx';
import Cookies from "js-cookie";


export class SessionStore {
    currentUser = {};
    isLoading = false;
    _accessToken = null;

    constructor(authService) {
        makeAutoObservable(this);
        this.authService = authService;
        this._accessToken = Cookies.get('token');
        this.getUser();
    }

    get token() {
        return this._accessToken;
    }

    get isAuthenticated() {
        return !!this._accessToken;
    }

    async getTokens() {
        const token = Cookies.get('token');

        if (token) {
            this._accessToken = token;
            await this.getUser();
        } else {
            this._accessToken = null;
        }
    }

    async setLoading(bool) {
        this.isLoading = bool;
    }

    async setUser(user) {
        return this.currentUser = user;
    }

    login = async(loginData) => {

        const response = await this.authService.login(loginData);

        const token = response.data.token.split(' ')[1];

        await this.setToken(token);
        await this.getUser();
    }

    async getUser() {
        try {
            await this.setLoading(true);
            if (this._accessToken){
                const result = await this.authService.findUserByToken();
                await this.setUser(result?.data);
            }

        } catch (e) {
            this.currentUser = {};
            await this.setToken(null);
            throw new Error('Something going wrong');
        } finally {
            await this.setLoading(false);
        }
    }

    async setToken(token) {

        if (token) {
            Cookies.set('token', token);
            this._accessToken = token;
        } else {
            this.clearToken();
        }
    }

    logOut = async () => {
        await this.setToken(null);
        await this.setUser({});
    }

    clearToken = () => {
        Cookies.remove('token');
        this._accessToken = null;
    }



}
